import request from '@/common/request'
import file from '@/common/fileDownload'
/** 
 *  create 增
 *  delete 删
 *  update 改
 *  query  查
*/
export default {
  createReportDesign: (data) => {
    return request({
      url: '/report/save',
      method: 'post',
      data
    })
  },
getFieldList: (dynaSeg) => {
    return request({
      url: `/report/getfieldList/${dynaSeg.value}`,
      method: 'get'
    })
  },
  updateReportDesign: (data) => {
    return request({
      url: `/report/update`,
      method: 'post',
      data
    })
  },
  queryReportDesign: params => {
    return request({
      url: '/report',
      method: 'get',
      params
    })
  },
  getElement: (dynaSeg) => {
    return request({
      url: `/report/element/${dynaSeg.reportType}`,
      method: 'get'
    })
  },
  getReportData: (data) => {
    return request({
      url: '/report/data/page',
      method: 'post',
      data
    })
  },
  getDesigner: (dynaSeg) => {
    return request({
      url: `/report/designer/${dynaSeg.reportType}`,
      method: 'get'
    })
  },
  reportExport:(dynaSeg,searchObj) =>{
    file.fileDownload(`/report/data/export/${dynaSeg.reportName}`,searchObj);
  }
}


// WEBPACK FOOTER //
// ./src/api/modules/reportDesign.js